var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidesVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "guides_videos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 0.67,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 0.67,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "guides_videos"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.98,
    cy: 301.17,
    r: 300,
    fill: "#a97fed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.32,264.91,247.78,153.17c-24.42-14.1-54.95,3.52-54.95,31.72V408.37c0,28.2,30.53,45.82,54.95,31.72L441.32,328.36C465.74,314.26,465.74,279,441.32,264.91Z",
    fill: "#efe9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesVideos);
export default __webpack_public_path__ + "static/media/guides_videos.45cb6675a1c44f180d52a7e7f500f8a7.svg";
export { ForwardRef as ReactComponent };